import { NgModule }                      from '@angular/core';
import { FormsModule }                   from '@angular/forms';
import { DirectivesModule }              from '../../directives/directives.module';
import { PipesModule }                   from '../../pipes/pipes.module';
import { CommonModule }                  from '@angular/common';
import { TurDebugPanelComponent }     from './tur-debug-panel/tur-debug-panel.component';
import { TurCoinTubesPanelComponent }         from './tur-cointubes-panel/tur-cointubes-panel.component';
import { TurHelpPanelComponent }          from './tur-help-panel/tur-help-panel.component';
import { TurLanguageSwitcherComponent }   from './tur-language-switcher/tur-language-switcher.component';
import { TurNotificationPopupComponent }  from './tur-notification-popup/tur-notification-popup.component';
import { TurPaymentPanelComponent }       from './tur-payment-panel/tur-payment-panel.component';
import { TurWarningPanelComponent }       from './tur-warning-panel/tur-warning-panel.component';
import { TurVendingProgressComponent }    from './tur-vending-progress/tur-vending-progress.component';
import { TurFillingPanelComponent }       from './tur-filling-panel/tur-filling-panel.component';
import { MatTabsModule }                  from "@angular/material/tabs";
import { TurConfigurationPanelComponent } from './tur-configuration-panel/tur-configuration-panel.component';
import { MatFormFieldModule }             from "@angular/material/form-field";
import { MatSelectModule }                from "@angular/material/select";

const COMPONENTS = [
	TurCoinTubesPanelComponent,
	TurDebugPanelComponent,
	TurHelpPanelComponent,
	TurLanguageSwitcherComponent,
	TurNotificationPopupComponent,
	TurPaymentPanelComponent,
	TurWarningPanelComponent,
	TurVendingProgressComponent,
	TurFillingPanelComponent,
	TurConfigurationPanelComponent
];

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
		DirectivesModule,
		PipesModule,
		MatTabsModule,
		MatFormFieldModule,
		MatSelectModule
	],
	exports: [...COMPONENTS],
	declarations: [...COMPONENTS]
})
export class TurComponentsModule {
}
